export default __webpack_public_path__ + "static/media/pdf.779d9fe0.svg";